import api from "@/lib/api";

export const MEALS = ["breakfast", "lunch", "dinner", "snack"];
export const mealForNow = () => { const d = new Date(); const h = d.getHours() + d.getMinutes() / 60; return h < 10.5 ? "breakfast" : h < 14.5 ? "lunch" : h < 17.5 ? "snack" : h < 22 ? "dinner" : "snack"; };
export const CORE = ["calories", "protein", "carbs", "fat"];
export const isoToday = () => { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`; };
export const shiftDate = (iso, days) => { const d = new Date(iso + "T12:00:00Z"); d.setUTCDate(d.getUTCDate() + days); return d.toISOString().slice(0, 10); };
export const newEntryId = () => (crypto.randomUUID ? crypto.randomUUID().replace(/-/g, "") : Math.random().toString(16).slice(2) + Date.now().toString(16));

const OFF_FIELDS = "code,product_name,product_name_fr,product_name_en,product_name_de,product_name_it,brands,image_front_small_url,nutriments,serving_size,serving_quantity,serving_quantity_unit,quantity";

// Repli côté navigateur (quota Open Food Facts par utilisateur) : la fiche brute est normalisée par le backend.
async function offDirectProduct(code) {
  const r = await fetch(`https://world.openfoodfacts.org/api/v2/product/${code}.json?fields=${OFF_FIELDS}`);
  if (r.status === 404) return null;
  if (!r.ok) throw new Error("off_unavailable");
  const d = await r.json();
  return d.status === 1 ? d.product : null;
}

export async function lookupBarcode(code) {
  try {
    return (await api.get(`/food/barcode/${code}`)).data.food;
  } catch (e) {
    if (e.response?.status === 404) return null;
    if (e.response?.status !== 503) throw e;
    const product = await offDirectProduct(code);
    if (!product) return null;
    return (await api.post("/food/cache", { product })).data.food;
  }
}

export async function searchFoods(q) {
  const { data } = await api.get("/food/search", { params: { q, off: true } });
  if (data.off_status !== "unavailable") return data;
  try {
    const r = await fetch(`https://search.openfoodfacts.org/search?q=${encodeURIComponent(q)}&page_size=15&fields=${OFF_FIELDS}`);
    if (!r.ok) return data;
    const hits = (await r.json()).hits || [];
    const cached = await Promise.all(hits.map((p) => api.post("/food/cache", { product: { ...p, brands: Array.isArray(p.brands) ? p.brands.join(", ") : p.brands } }).then((x) => x.data.food).catch(() => null)));
    const seen = new Set(data.foods.map((f) => f.food_id));
    return { ...data, foods: [...data.foods, ...cached.filter((f) => f && !seen.has(f.food_id))], off_status: "ok_client" };
  } catch { return data; }
}

// Apports pour une quantité donnée (miroir du calcul serveur, pour l'aperçu en direct)
export function previewNutrition(food, quantity, unit) {
  const per = food.per_100g || {};
  const grams = unit === "portion" ? (food.serving_grams ? quantity * food.serving_grams : null) : quantity;
  if (grams == null) return null;
  const f = grams / 100;
  const out = {};
  for (const k of ["calories", "protein", "carbs", "fat", "fiber", "sugars", "salt"]) {
    out[k] = per[k] == null ? null : (k === "calories" ? Math.round(per[k] * f) : Math.round(per[k] * f * 10) / 10);
  }
  return out;
}

export function errorKey(e) {
  const d = e?.response?.data?.detail;
  if (d === "recipe_locked") return "j_err_locked";
  if (d === "unit_invalid" || d === "serving_unknown") return "j_err_unit";
  if (d === "nutrition_core_required") return "j_core_required";
  return "j_err_generic";
}
